import { Directive, computed, input } from '@angular/core';
import { CALLOUT_TONES, type CalloutTone } from '@groove/core';

// The tone vocabulary is owned by @groove/core (framework-neutral, so the
// coverage engine can read it without pulling in @angular/core). Re-exported
// here so consumers can keep importing it from the directive.
export { CALLOUT_TONES, type CalloutTone };

/**
 * Callout / note element (component tier). Accent-leading-border surface; `tone`
 * selects the border colour.
 *
 * The former `quote` mode is retired: pull-quote presentation is owned by the
 * single site-wide quote vocabulary, [groovePullquote]. The callout is for
 * notes and warnings only.
 */
@Directive({
  selector: '[grooveCallout]',
  standalone: true,
  host: {
    class: 'groove-callout',
    '[attr.data-tone]': 'toneAttr()',
  },
})
export class GrooveCalloutDirective {
  readonly tone = input<CalloutTone>('info');

  protected readonly toneAttr = computed(() =>
    this.tone() === 'info' ? null : this.tone(),
  );
}
